import { useMemo } from 'react';
import { AnalysisDetail } from '@/api/domains/analyses/types';

type ViewState =
  | 'INITIAL_LOADING'
  | 'ERROR'
  | 'PROCESSING'
  | 'EMPTY_RESULTS'
  | 'SHOW_FINDINGS';

interface UseAnalysisViewStateParams {
  analysis: AnalysisDetail | undefined;
  isLoading: boolean;
  isError: boolean;
}

export const useAnalysisViewState = ({
  analysis,
  isLoading,
  isError
}: UseAnalysisViewStateParams): ViewState => {
  return useMemo<ViewState>(() => {
    if (isLoading || !analysis) {
      return 'INITIAL_LOADING';
    }

    if (isError || analysis.status === 'FAILED') {
      return 'ERROR';
    }

    const isProcessing =
      analysis.status === 'PROCESSING' || analysis.status === 'PENDING';

    if (isProcessing) {
      return 'PROCESSING';
    }

    const findings = analysis.findings || [];
    if (findings.length === 0) {
      return 'EMPTY_RESULTS';
    }

    return 'SHOW_FINDINGS';
  }, [isLoading, analysis, isError]);
};
